import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { InsightsDataProvider } from './contexts/insightsData';
import './translate';
import 'apexcharts/dist/apexcharts.css';
import { purgeLegacyAuthArtifacts } from './shared/auth/tokenStore';
import { setOnAuthFailure, refreshAccessToken } from './shared/api/client';
import { IAM_URL } from './utils/constants';

async function boot() {
  purgeLegacyAuthArtifacts();

  setOnAuthFailure(() => {
    window.location.href = `${IAM_URL}/#/logout`;
  });

  try {
    await refreshAccessToken();
  } catch {}

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <React.StrictMode>
      <InsightsDataProvider>
        <App />
      </InsightsDataProvider>
    </React.StrictMode>
  );
}

void boot();

reportWebVitals();
